(() => {
  if (window.nuoneoCartDrawerLoaded) return;
  window.nuoneoCartDrawerLoaded = true;

  const freeShippingThreshold = 5900;
  let timerInterval;

  const getCustomizationRoot = () => document.querySelector('[data-free-shipping-message]');

  const formatMoney = (cents) => {
    const locale = document.documentElement.lang || 'de-DE';
    const currency = window.Shopify?.currency?.active || 'EUR';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
  };

  const getCart = async () => {
    const rootUrl = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${rootUrl}cart.js`, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  };

  const updateProgress = async () => {
    const customizationRoot = getCustomizationRoot();
    const fill = document.getElementById('fs-fill');
    const icon = document.getElementById('fs-icon');
    const message = document.getElementById('fs-message');
    const truck = document.querySelector('.truck-icon-wrapper');
    if (!customizationRoot || !fill || !message) return;

    try {
      const cart = await getCart();
      const total = cart.total_price || 0;
      const progress = Math.min(100, Math.max(0, Math.round((total * 100) / freeShippingThreshold)));
      const remaining = Math.max(0, freeShippingThreshold - total);

      fill.style.width = `${progress}%`;
      if (icon) icon.style.right = `calc(${100 - progress}% - 12px)`;

      if (progress >= 100) {
        message.innerHTML = customizationRoot.dataset.freeShippingMessage;
        truck?.classList.add('glow');
      } else {
        message.innerHTML = customizationRoot.dataset.remainingMessage.replace('__AMOUNT__', formatMoney(remaining));
        truck?.classList.remove('glow');
      }
    } catch {
      message.textContent = '';
    }
  };

  const startTimer = () => {
    const timer = document.getElementById('cart-timer');
    if (!timer) return;

    window.clearInterval(timerInterval);
    let seconds = 15 * 60;

    const tick = () => {
      timer.textContent = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
      if (seconds > 0) seconds -= 1;
    };

    tick();
    timerInterval = window.setInterval(tick, 1000);
  };

  const refresh = () => {
    updateProgress();
    startTimer();
  };

  document.addEventListener('DOMContentLoaded', () => {
    refresh();
    if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.openCartDrawer) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openCartDrawer, refresh);
    }
  });

  document.addEventListener('cart:updated', updateProgress);
  document.addEventListener('cart:refresh', () => window.setTimeout(updateProgress, 500));

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-upsell-add]');
    if (!form) return;

    event.preventDefault();
    const button = form.querySelector('.cart-upsell-button');
    if (!button || button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.labelAdding;

    try {
      const endpoint = form.action.endsWith('.js') ? form.action : `${form.action}.js`;
      const response = await fetch(endpoint, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error('Cart add failed');

      button.textContent = button.dataset.labelAdded;
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    } catch {
      button.textContent = button.dataset.labelError;
      window.setTimeout(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = button.dataset.labelDefault;
      }, 2000);
    }
  });
})();
